import { render, staticRenderFns } from "./AddComment.vue?vue&type=template&id=024d1c98&scoped=true&"
import script from "./AddComment.vue?vue&type=script&lang=js&"
export * from "./AddComment.vue?vue&type=script&lang=js&"
import style0 from "./AddComment.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddComment.vue?vue&type=style&index=1&id=024d1c98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d1c98",
  null
  
)

export default component.exports